<template>
  <div class="ss-dropdown" ref="wrapper">
    <button class="ss-dropdown__trigger" @click.stop="toggleOpen">
      <span>{{ triggerLabel }}</span>
      <!-- <i class="fas fa-chevron-down ss-dropdown__chevron" :class="{ 'is-open': isOpen }"></i> -->
      <font-awesome-icon icon="chevron-down" class="domain-dropdown__chevron" :class="{ 'is-open': isOpen }" />
    </button>

    <div v-if="isOpen" class="ss-dropdown__panel" @click.stop>
      <div class="ss-dropdown__header">
        <span class="ss-dropdown__title">{{ title }}</span>
      </div>

      <div class="ss-dropdown__search-wrap">
        <!-- <i class="fas fa-search ss-dropdown__search-icon"></i> -->
        <font-awesome-icon icon="search" style="font-size: 12px; color: #e3e3e3;" />
        <input v-model="search" class="ss-dropdown__search-input"
          :placeholder="`Search ${title.toLowerCase().replace('select ', '')}`" @click.stop />
      </div>

      <div class="ss-dropdown__list">
        <div v-for="opt in filteredOptions" :key="opt.value" class="ss-dropdown__item"
          :class="{ 'is-selected': isSelected(opt) }" @click.stop="selectOption(opt)">
          <span class="ss-dropdown__radio" :class="{ 'is-checked': isSelected(opt) }"></span>
          <span>{{ opt.name }}</span>
        </div>
        <p v-if="filteredOptions.length === 0" class="ss-dropdown__empty">{{ emptyMessage }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleSelectDropdown',
  props: {
    value: {
      type: Object,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Select',
    },
    title: {
      type: String,
      default: 'Select',
    },
    emptyMessage: {
      type: String,
      default: 'No results',
    },
  },
  data() {
    return {
      isOpen: false,
      search: '',
    }
  },
  computed: {
    triggerLabel() {
      return this.value ? this.value.name : this.placeholder
    },
    filteredOptions() {
      const q = this.search.toLowerCase()
      if (!q) return this.options
      return this.options.filter(opt => opt.name.toLowerCase().includes(q))
    },
  },
  mounted() {
    this._closeHandler = (e) => {
      if (this.$refs.wrapper && !this.$refs.wrapper.contains(e.target)) {
        this.isOpen = false
      }
    }
    document.addEventListener('click', this._closeHandler)
  },
  beforeDestroy() {
    document.removeEventListener('click', this._closeHandler)
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.search = ''
        this.$emit('open')
      }
    },
    close() {
      this.isOpen = false
    },
    isSelected(opt) {
      return this.value && this.value.value === opt.value
    },
    selectOption(opt) {
      if (this.isSelected(opt)) {
        this.$emit('input', null)
      } else {
        this.$emit('input', opt)
      }
      this.isOpen = false
    },
  },
}
</script>

<style scoped>
.ss-dropdown {
  position: relative;
  width: 100%;
}

.ss-dropdown__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 28px;
  padding: 0 8px;
  background: white;
  border: none;
  border-radius: 4px;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
  font-size: 12px;
  font-weight: 500;
  color: #4b4b4b;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ss-dropdown__trigger:hover {
  background: #f5f5f5;
}

.ss-dropdown__chevron {
  font-size: 10px;
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

.ss-dropdown__chevron.is-open {
  transform: rotate(180deg);
}

.ss-dropdown__panel {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 220px;
  z-index: 10;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
  padding: 13px;
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.ss-dropdown__header {
  display: flex;
  align-items: flex-end;
}

.ss-dropdown__title {
  font-size: 13px;
  font-weight: 500;
  color: #4b4b4b;
}

.ss-dropdown__search-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 37px;
  padding: 0 10px;
  border: 1px solid #e3e3e3;
  border-radius: 5px;
}

.ss-dropdown__search-icon {
  color: #e3e3e3;
  font-size: 14px;
  flex-shrink: 0;
}

.ss-dropdown__search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  color: #4b4b4b;
  background: transparent;
}

.ss-dropdown__search-input::placeholder {
  color: #e3e3e3;
}

.ss-dropdown__list {
  max-height: 160px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ss-dropdown__list::-webkit-scrollbar {
  width: 4px;
}

.ss-dropdown__list::-webkit-scrollbar-track {
  background: transparent;
}

.ss-dropdown__list::-webkit-scrollbar-thumb {
  background: #e3e3e3;
  border-radius: 8px;
}

.ss-dropdown__item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #393939;
  font-weight: 400;
  user-select: none;
}

.ss-dropdown__item:hover .ss-dropdown__radio {
  border-color: #4b4b4b;
}

.ss-dropdown__radio {
  width: 12px;
  height: 12px;
  border: 1px solid #d7d6d6;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
  transition: border-color 0.1s;
}

.ss-dropdown__radio.is-checked {
  border-color: #4b4b4b;
}

.ss-dropdown__radio.is-checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background: #4b4b4b;
  border-radius: 50%;
}

.ss-dropdown__empty {
  font-size: 12px;
  color: #a0a0a0;
  margin: 0;
  text-align: center;
}
</style>
